import { css } from '@emotion/react';

export const GlOBAL_VISIT_CSS = css`
  header.logo-layout {
    display: -moz-box;
    display: flex;
    -moz-box-align: center;
    align-items: center;
    padding-left: 20px;
    height: 88px;
    background-color: #fff;
    color: #d60035;
    font-size: 43px;
  }

  header.logo-layout > span {
    display: contents;
    -moz-box-align: center;
    align-items: center;
    color: #000;
    font-size: 30px;
  }

  header.logo-layout p.logo-description {
    -moz-box-align: center;
    align-items: center;
    padding-left: 20px;
    color: #3a3939;
    font-weight: 600;
    font-size: 17px;
    line-height: 23.7999992371px;
  }

  header.logo-layout img {
    display: block;
    margin-left: 20px;
    width: 219px;
    height: auto;
  }

  header.logo-layout .linked-icon {
    cursor: pointer;
  }

  header.title-layout {
    display: -moz-box;
    display: flex;
    -moz-box-align: center;
    align-items: center;
    -moz-box-pack: center;
    justify-content: center;
    max-height: 70px;
    width: 100%;
    height: 70px;
    background-color: #d60035;
  }

  header.title-layout > h2.title {
    color: #fff;
    font-weight: 400;
    font-size: 30px;
  }
  footer {
    bottom: 0;
    display: block;
    margin-top: 80px;
    width: 100%;
    height: 184px;
    background-color: #000;
  }

  footer,
  footer > .layout {
    -moz-box-align: center;
    align-items: center;
    text-align: center;
  }

  footer > .layout {
    display: -moz-box;
    display: flex;
    -moz-box-pack: center;
    justify-content: center;
    height: 100%;
  }

  footer > .layout > div > .title {
    margin-bottom: 0.5rem;
    color: #fff;
    font-size: 1.5rem;
  }

  footer > .layout > div > .title span {
    color: #d60035;
    font-size: 4rem;
  }

  footer > .layout > div > .content {
    color: #fff;
    font-size: 9px;
  }

  footer > .layout > div > .title > img {
    margin-bottom: 20px;
    width: 170px;
  }

  footer .footer-arrow-icon {
    position: absolute;
    right: 30px;
    display: block;
    margin-top: 40px;
    color: #c9caca;
    cursor: pointer;
  }
  @media only screen and (min-width: 576px) and (max-width: 991px) {
    header.logo-layout {
      height: 60px;
    }

    header.logo-layout > img {
      width: 146px;
    }

    header.logo-layout p.logo-description {
      display: none;
    }

    header.title-layout {
      height: 58px;
    }

    header.title-layout > h2.title {
      font-size: 24px;
    }

    header.content-layout-black {
      height: 120px;
    }

    header.content-layout-white {
      padding: 50px 0 49px;
      height: 135px;
    }

    header.content-layout-white > span {
      font-size: 24px;
      line-height: 36px;
    }

    header.content-layout-white.no-title-layout {
      padding-top: 108px;
    }

    .top-section-layout {
      margin-top: 38px;
    }

    .top-section-step {
      margin-right: 8px;
      width: 80px;
      height: 34px;
      border-radius: 17px;
      font-size: 14px;
      line-height: 20px;
    }

    .top-section-step-number {
      font-size: 21px;
      line-height: 31px;
    }

    .top-section-content {
      letter-spacing: 1.2px;
      font-size: 24px;
      line-height: 36px;
    }

    footer {
      position: relative;
      margin-top: 70px;
      height: 108px;
    }

    footer > .layout > div > .content {
      font-size: 8px;
    }

    footer > .layout > div > .title > img {
      margin-bottom: 10px;
      width: 140px;
    }

    footer .footer-arrow-icon {
      display: none;
    }

    .main-layout {
      padding-right: 4%;
      padding-left: 4%;
      width: 100%;
    }

    .mid-section-layout {
      padding-top: 7px;
    }

    .bottom-section-layout {
      margin: 50px auto 70px;
    }

    .button-common {
      margin: 0 10px;
      width: 255px;
      height: 50px;
      letter-spacing: 0.7px;
      font-size: 14px;
      line-height: 20px;
    }

    .button-right-arrow {
      right: 21px;
      width: 15px;
      height: 15px;
    }

    .button-left-arrow {
      left: 21px;
      width: 15px;
      height: 15px;
    }
  }

  @media only screen and (max-width: 575px) {
    header.logo-layout {
      height: 60px;
    }

    header.logo-layout p.logo-description {
      display: none;
    }

    header.logo-layout > img {
      margin-left: 10px;
      width: 146px;
    }

    header.title-layout > h2.title {
      font-size: 24px;
    }

    header.content-layout-black {
      max-height: 100px;
      height: 17.49vw;
    }

    header.content-layout-white {
      padding: 50px 0 49px;
      height: 125px;
    }

    header.content-layout-white > span {
      font-size: 24px;
      line-height: 36px;
    }

    header.content-layout-white.no-title-layout {
      padding-top: 93px;
    }

    .top-section-layout {
      margin-top: 38px;
    }

    .top-section-step {
      margin-right: 8px;
      min-width: 80px;
      width: 80px;
      height: 34px;
      border-radius: 17px;
      font-size: 14px;
      line-height: 20px;
    }

    .top-section-step-number {
      font-size: 21px;
      line-height: 31px;
    }

    .top-section-content {
      letter-spacing: 1.2px;
      font-size: 24px;
      line-height: 30px;
    }

    footer {
      margin-top: 70px;
      height: 108px;
    }

    footer > .layout > div > .content {
      font-size: 8px;
    }

    footer > .layout > div > .title > img {
      margin-bottom: 10px;
      width: 140px;
      height: auto;
    }

    footer .footer-arrow-icon {
      display: none;
    }

    .main-layout {
      padding-right: 4%;
      padding-left: 4%;
      width: 100%;
    }

    .mid-section-layout {
      padding-top: 0;
    }

    .bottom-section-layout {
      margin: 50px auto;
    }

    .button-common {
      margin: 0 10px;
      width: 255px;
      height: 50px;
      letter-spacing: 0.7px;
      font-size: 14px;
      line-height: 20px;
    }

    .button-right-arrow {
      right: 21px;
      width: 15px;
      height: 15px;
    }

    .button-left-arrow {
      left: 21px;
      width: 15px;
      height: 15px;
    }
  }

  @media only screen and (min-width: 429px) and (max-width: 575px) {
    header.title-layout {
      max-height: 58px;
      height: 10.035vw;
    }
  }
  @media screen and (min-width: 992px) {
    hr {
      height: 3px !important;
      border: none;
      background-color: #fff;
    }
  }

  @media screen and (max-width: 991px) {
    hr {
      height: 2px !important;
      border: none;
      background-color: #fff;
    }
  }

  .step-navigation hr.todo {
    opacity: 0.5;
  }

  @media screen and (max-width: 840px) {
    .step-navigation .todo .title {
      display: none;
      border-color: #fff;
    }
  }
`;
